import gql from 'graphql-tag';

export const MEMBER_DISPLAY_FRAGMENT = gql`
  fragment MemberDisplay on Member {
    id
    firstName
    lastName
  }
`;
